import { CardParam } from "interfaces/Home";
import { ActionData as Action } from "reducers/IAction";
import { ScenarioTypes } from "constant";

export type ParamsState = Array<CardParam>;

/**
 * Reducer qui permet de gérer la listes des cards
 *
 * @export
 * @param {ParamsState} [state=[]] state redux
 * @param {Action<{ params: Array<CardParam> }>} action action possible
 * @returns {ParamsState} state redux
 */
export default function reducerParams(
  state: ParamsState = [],
  action: Action<{ params: Array<CardParam> }>
): ParamsState {
  switch (action.type) {
    case ScenarioTypes.FETCH_TRANSACTION_SUCCESS:
      return action.payload.params;
    case ScenarioTypes.FETCH_TRANSACTION_ERROR:
      return [];
    default:
      return state;
  }
}
